import { FCX } from "@datassential/platform-ui-lib";
import HomeSectionHeader from "@pages/Home/components/HomeSectionHeader";
import HomeSectionTitle from "@pages/Home/components/HomeSectionTitle";
import HomeFoodsLtos from "@pages/Home/sections/HomeFoods/HomeFoodsLtos";
import HomeSectionDelimiter from "@pages/Home/components/HomeSectionDelimiter";
import React from "react";
import HomeFoodsMenuGrowth from "@pages/Home/sections/HomeFoods/HomeFoodsMenuGrowth";

const HomeFoods: FCX = () => {
    return (
        <div className="Home__wrapper">
            <HomeSectionHeader>
                <HomeSectionTitle>Foods</HomeSectionTitle>
            </HomeSectionHeader>
            <div className="Home__sub-wrapper">
                <HomeFoodsLtos/>
                <HomeSectionDelimiter colors={[]} noLogo/>
                <HomeFoodsMenuGrowth/>
            </div>
            <HomeSectionDelimiter colors={['#1DFEEC', '#FFCD00', '#FF8E00']}/>
        </div>
    );
}

export default HomeFoods;